import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScacLookup extends Layout {
    sourceCarrierScac: DataSource;
    tableCarrierScac: Table;
}
